import React, { useEffect } from 'react';
import { ThemeProvider, CssBaseline, Box } from '@material-ui/core';
import { Box as AWSUIBox, Container as AWSUIContainer } from '@amzn/awsui-components-react-v3';
import { websiteViewTheme } from '../website-view/styles/theme';
import { useAppLayoutStyles } from '../website-view/styles/app-layout.styles';
import '../website-view/styles/page-shell.scss';
import { FunnelPanel } from '../shared-panels/FunnelPanel';
import { SlaPanel } from '../shared-panels/sla/SlaPanel';
import { metricFeaturesList, metricPageNames } from 'src/constants/swo-ui-metric-constants';
import { SwoUiMetrics } from 'src/utils/swo-ui-metrics/swo-ui-metrics';

/**
 * Cross-website counterpart to the Website View: the same panels, aggregated over every website
 * instead of scoped to one.
 *
 * Scope is COHORT with no website filter. That is the one scope the backend allows to run unbounded —
 * cross-website aggregation is the point here, whereas a WEBSITE request without a website_id is
 * rejected because it would report every website's total as one website's funnel.
 *
 * Theme and layout styles are reused from the Website View so the two pages stay visually identical;
 * only the scope differs.
 */
export const AggregateViewLayout = React.memo(() => {
    const classes = useAppLayoutStyles();

    useEffect(() => {
        SwoUiMetrics.publishCloudWatchCountMetric(
            metricPageNames.aggregateView,
            metricFeaturesList.allWebsitesAnalysisAndDiagnosticTool
        );
    }, []);

    return (
        <ThemeProvider theme={websiteViewTheme}>
            <CssBaseline />
            <Box className="ovp-page">
                <Box className="ovp-page__wrap">
                    <AWSUIContainer header={
                        <AWSUIBox variant="h2" padding={{ top: 'm' }}>
                            All Websites Flow Analysis &amp; Diagnostic Tool
                        </AWSUIBox>
                    }>
                        <AWSUIBox variant="p" color="text-body-secondary">
                            Aggregated across every website in the selection pipeline.
                        </AWSUIBox>
                    </AWSUIContainer>

                    <Box component="main" className={classes.mainContent}>
                        <Box className={classes.cardContainer}>
                            <FunnelPanel scope={{ type: 'COHORT' }} />
                        </Box>
                        <Box className={classes.cardContainer}>
                            <SlaPanel scope={{ type: 'COHORT' }} />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </ThemeProvider>
    );
});

AggregateViewLayout.displayName = 'AggregateViewLayout';
